import { ChangeDetectionStrategy, Component, output, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IrisIconComponent, IconSizes } from '@sondermind/iris/icon';

import { AmplitudeFlagToolService } from '../../services/amplitude-flag-tool.service';

@Component({
  selector: 'amplitude-flag-tool',
  standalone: true,
  imports: [
    CommonModule,
    IrisIconComponent
  ],
  templateUrl: './amplitude-flag-tool.component.html',
  styleUrl: './amplitude-flag-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmplitudeFlagToolComponent {
  readonly iconSizes = IconSizes;
  readonly searchQuery = signal('');

  readonly back = output<void>();

  readonly filteredFlags = computed(() => {
    const query = this.searchQuery().toLowerCase();
    const all = this.service.flags();
    if (!query) return all;
    return all.filter((f) => f.key.toLowerCase().includes(query));
  });

  constructor(public service: AmplitudeFlagToolService) {}

  onBack(): void {
    this.back.emit();
  }

  onToggle(flagKey: string): void {
    this.service.toggleFlag(flagKey);
  }

  onClearAll(): void {
    this.service.clearAllOverrides();
  }

  onSearchInput(event: Event): void {
    const { value } = event.target as HTMLInputElement;
    this.searchQuery.set(value);
  }
}
